import { IProduct } from 'services/dcs/bundle';
import { ProductModule, ContentType } from 'api/contentful/contentTypes.cloverdotcom';

export interface IBYOPricingProps {
  dcsIds: string[];
  contentType: ContentType;
  quantity?: number;
  isSystemPreviewDrawer?: boolean;
}

export const translationKeyMap = {
  UPFRONT: {
    primary: 'build-your-own.pricing.upfront',
    secondary: 'build-your-own.pricing.upfront-secondary',
  },
  MONTHLY: {
    primary: 'build-your-own.pricing.monthly',
    secondary: 'build-your-own.pricing.monthly-secondary',
  },
};

export const areBYOProductsSelfServiceEnabled = (
  dcsProducts?: IProduct[],
  productModules?: ProductModule[],
): boolean => {
  if (!dcsProducts?.length || !productModules?.length) return false;

  const productModuleDcsIds = productModules.map(productModule => productModule.dcsId);
  const filteredDcsProducts = dcsProducts.filter(dcsProduct => productModuleDcsIds.includes(dcsProduct.id));

  return filteredDcsProducts.every(dcsProduct => dcsProduct.isSelfServicePurchaseEnabled);
};
